export default function HWY_Etched() {
    var data = jQuery(
        ".etched-page input[type=radio][name=product]:checked"
    ).data("product");
    var metaData = {};
    this.init = () => {
        changeWine();
        noteWine();
        addToCart();
        fetchData();
    };
    const fetchData = () => {
        jQuery(document).ready(function ($) {
            if ($(".etched-page")) {
                var url = new URL(window.location.href);
                var searchParams = url.searchParams;
                var metaEtchedSignOff = searchParams.get("meta-etched-sign-off");
                var greeting = searchParams.get("meta-etched-greeting");
                var message = searchParams.get("meta-etched-message");
                if (greeting) {
                    $(
                        ".product-detail .product-detail-info .form-meta input[name=greeting]"
                    ).val(greeting);
                }
                if (metaEtchedSignOff) {
                    $(
                        ".product-detail .product-detail-info .form-meta input[name=sign_off]"
                    ).val(metaEtchedSignOff);
                }
                if (message) {
                    $(
                        ".product-detail .product-detail-info .form-meta input[name=message]"
                    ).val(message);
                }
            }
        });
    };
    const changeWine = () => {
        jQuery(".etched-page input[type=radio][name=product]").change(function () {
            const checked = jQuery(
                ".etched-page input[type=radio][name=product]:checked"
            );
            const dataProduct = checked.data("product");
            data = dataProduct;
            jQuery(".etched-page .product-detail-image img").attr(
                "src",
                dataProduct.image
            );
            if (typeof dataProduct.variants[0] == "undefined") {
                jQuery(".etched-page .product-detail-info .product-price").hide();
                jQuery(".etched-page .product-detail-info .box-add-to-cart").hide();
            } else {
                jQuery(".etched-page .product-detail-info .product-price").show();
                jQuery(".etched-page .product-detail-info .box-add-to-cart").show();
                jQuery(
                    ".etched-page .product-detail-info .product-price .price-discounted"
                ).html(`<span class="price-original d-none"></span>
            $${dataProduct.variants[0].price / 100}`);
                if (dataProduct.variants[0].comparePrice) {
                    jQuery(
                        ".etched-page .product-detail-info .product-price .price-original"
                    ).text("$" + dataProduct.variants[0].comparePrice / 100);
                    jQuery(
                        ".etched-page .product-detail-info .product-price .price-original"
                    ).removeClass("d-none");
                }
            }
        });
    };
    const noteWine = () => {
        jQuery(".etched-page .form-meta input, .form-meta textarea").on(
            "keyup",
            function () {
                const dataFormArr = jQuery(".etched-page .form-meta").serializeArray();
                const dataFormObj = {};

                for (let i = 0; i < dataFormArr.length; i++) {
                    const obj = dataFormArr[i];
                    const value = obj.value;
                    const name = obj.name;
                    dataFormObj[name] = value;
                }
                metaData = dataFormObj;
                if (jQuery(".etched-page .product-detail-image .data-note")) {
                    jQuery(".etched-page .product-detail-image .data-note").remove();
                }
                const html = `<div class="data-note">
        <p class="data-note-greeting">${dataFormObj.greeting}</p>
        <p class="data-note-message">${dataFormObj.message}</p>
        <p class="data-note-sign-off">${dataFormObj.sign_off}</p>
    </div>`;
                if (
                    !jQuery(".etched-page .product-detail-image img").hasClass("zoom")
                ) {
                    jQuery(".etched-page .product-detail-image img").addClass("zoom");
                    setTimeout(function () {
                        jQuery(".etched-page .product-detail-image").append(html);
                    }, 1000);
                } else {
                    jQuery(".etched-page .product-detail-image").append(html);
                }
            }
        );
    };
    const addToCart = () => {
        jQuery(".etched-page .product-detail-info .btn-add-to-cart").click(
            function () {
                if (typeof data.variants[0] == "undefined") {
                    return;
                }
                let addToCartUrl =
                    window.location.origin +
                    window.location.pathname +
                    "?addToCart=" +
                    data.variants[0].sku +
                    "&meta-etched-greeting=" +
                    encodeURIComponent(metaData.greeting) +
                    "&meta-etched-message=" +
                    encodeURIComponent(metaData.message) +
                    "&meta-etched-sign-off=" +
                    encodeURIComponent(metaData.sign_off);
                window.location.href = addToCartUrl;
            }
        );
    };
}
